import { getCookie, setCookie } from './cookie';

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
const cookie = getCookie('wp-vb-utm');
let utm = null;

if (cookie) {
  try {
    utm = JSON.parse(cookie);
  } catch (e) {}
}

if (
  params.utm_source ||
  params.utm_medium ||
  params.utm_campaign ||
  params.utm_term ||
  params.utm_content ||
  params.gclid
) {
  const newUtm = {};

  newUtm.source = params.utm_source ?? utm?.source;
  newUtm.medium = params.utm_medium ?? utm?.medium;
  newUtm.campaign = params.utm_campaign ?? utm?.campaign;
  newUtm.term = params.utm_term ?? utm?.term;
  newUtm.content = params.utm_content ?? utm?.content;
  newUtm.gclid = params.gclid ?? utm?.gclid;

  utm = newUtm;

  setCookie('wp-vb-utm', JSON.stringify(utm), 14);
}

export { utm };